import { render, staticRenderFns } from "./batchPublish.vue?vue&type=template&id=1b91b69f&scoped=true"
import script from "./batchPublish.vue?vue&type=script&lang=js"
export * from "./batchPublish.vue?vue&type=script&lang=js"
import style0 from "./batchPublish.vue?vue&type=style&index=0&id=1b91b69f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b91b69f",
  null
  
)

export default component.exports